import './elements/cart/cart-add-update-delete';
import './elements/cart/cart-discount';
import './elements/cart/cart-giftcard';
import './elements/cart/cart-mini-cart';
import './elements/cart/cart-transport';
import './elements/cart/notification';

$(document).ready(function () {
    RemoveGiftCardCode();
});